import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import { styled } from "@mui/material/styles";
import Footer from "_shared/_views/footers/footer";
import Header from "_shared/_views/headers/header";
import { Outlet } from "react-router";

const Root = styled(Box)(() => ({
  alignItems: 'stretch',
  display: 'flex',
  flexDirection: 'row',
  height: '100%',
  width: '100%'
}));
const MainContainer = styled('main')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  padding: theme.spacing(8, 0, 0, 0),
  width: '100%',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(7, 0, 0, 0)
  }
}));
const PageContent = styled('section')(() => ({
  flexGrow: 1
}));

export default function Minimal() {
  return (
    <Root>
      <CssBaseline />
      <Header hideControls />
      <MainContainer>
        <PageContent>
          <Outlet />
        </PageContent>
        <Footer />
      </MainContainer>
    </Root>
  )
}
